import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mapBoundsContains',
    standalone: false,
})
export class MapBoundsContainsPipe implements PipeTransform {
    transform(
        bounds: google.maps.LatLngBounds | null | undefined,
        point: google.maps.LatLngLiteral | google.maps.LatLng | google.maps.LatLngBounds | null | undefined
    ): boolean {
        if (!bounds || !point) {
            return false;
        }

        // Bounds (e.g. of a polygon) are visible as soon as they overlap the map bounds
        if (point instanceof google.maps.LatLngBounds) {
            return bounds.intersects(point);
        }

        return bounds.contains(point);
    }
}
